import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment';
import { CryptoJSConfig } from '../config/crypto-js.config';

const namespace: string = environment.namespaceProject;
const SECRET_KEY: string = CryptoJSConfig.getKey();

@Injectable({
  providedIn: 'root'
})
export class StorageService {


  public setInLocalStorage(keyName: string, value: any): void {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
    localStorage.setItem(`${namespace}.${keyName}`, encryptedValue);
  }

  public getFromLocalStorage(keyName: string, convertToJson: boolean = false): any {
    const encryptedValue = localStorage.getItem(`${namespace}.${keyName}`);
    if (encryptedValue) {
      const decryptValue = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY).toString(CryptoJS.enc.Utf8);

      if (convertToJson) {
        return JSON.parse(decryptValue);
      } else {
        return decryptValue.replace(/^"|"$|"/g, ''); // Substitui aspas duplas no início, final e espaço em branco entre aspas // remove as aspas duplas extra
      }
    }
    return null;
  }

  public clearLocalStorage() {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.includes(namespace)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));

  }

  public setInSessionStorage(keyName: string, value: any): void {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
    sessionStorage.setItem(`${namespace}.${keyName}`, encryptedValue);
  }

  public getFromSessionStorage(keyName: string, convertToJson: boolean = false): any {
    const encryptedValue = sessionStorage.getItem(`${namespace}.${keyName}`);
    if (encryptedValue) {
      const decryptValue = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY).toString(CryptoJS.enc.Utf8);

      if (convertToJson) {
        return JSON.parse(decryptValue);
      } else {
        return decryptValue;
      }

    }
    return null;
  }

  public clearSessionStorage() {
    for( let i = 0; i < sessionStorage.length; i ++) {
      const key = sessionStorage.key(i);
      if (key.includes(namespace)) {
        sessionStorage.removeItem(key);
      }
    }
  }

  public getAnoLetivo() {
    return this.getFromLocalStorage('anoLetivo', true).ano;
  }

  public getAnoLetivoId() {
    return this.getFromLocalStorage('anoLetivo', true).id;
  }
}
